import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext({ dark: false, toggle: () => {} });

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(
    () => localStorage.getItem("sursadhana-theme") === "dark"
  );

  useEffect(() => {
    document.body.classList.toggle("dark", dark);
  }, [dark]);

  function toggle() {
    setDark(d => {
      const next = !d;
      localStorage.setItem("sursadhana-theme", next ? "dark" : "light");
      return next;
    });
  }

  return (
    <ThemeContext.Provider value={{ dark, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
